import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "주차팅",
    isTitle: true,
  },
  {
    id: 2,
    label: "대시보드",
    icon: "bx-home-circle",
    link: "/",
  },
  {
    id: 3,
    isLayout: true,
  },
  {
    id: 4,
    label: "운영관리",
    icon: "bx-cog",
    subItems: [
      {
        id: 43,
        label: "기본정보 관리",
        link: "/admin/basic-info",
        parentId: 4,
      },
      {
        id: 44,
        label: "링크 관리",
        link: "/admin/link-management",
        parentId: 4,
      },
    ],
  },
  {
    id: 5,
    label: "회원관리",
    icon: "bx-group",
    subItems: [
      {
        id: 51,
        label: "전체회원",
        link: "/user/all-members",
        parentId: 5,
      },
    ],
  },
  {
    id: 6,
    label: "메인 콘텐츠 관리",
    icon: "bx-book-content",
    subItems: [
      {
        id: 61,
        label: "배너 관리",
        link: "/content/main-management",
        parentId: 6,
      },
      {
        id: 62,
        label: "추천 주차장 관리",
        link: "/content/recommended-parking",
        parentId: 6,
      },
    ],
  },
  {
    id: 7,
    label: "주차장 관리",
    icon: "bx-car",
    subItems: [
      {
        id: 71,
        label: "주차장 리스트",
        link: "/parking/parking-list",
        parentId: 7,
      },
      {
        id: 72,
        label: "이용 내역 리스트",
        link: "/parking/usage-history",
        parentId: 7,
      },
    ],
  },
  {
    id: 8,
    label: "승인 관리",
    icon: "bx-check-circle",
    subItems: [
      {
        id: 81,
        label: "차량 변경 승인",
        link: "/approval/vehicle-change",
        parentId: 8,
      },
      {
        id: 82,
        label: "주차장 제공 신청 관리",
        link: "/approval/parking-application",
        parentId: 8,
      },
    ],
  },
  {
    id: 9,
    label: "결제환불 관리",
    icon: "bx-money",
    subItems: [
      {
        id: 91,
        label: "결제 내역",
        link: "/payment/payment-history",
        parentId: 9,
      },
      {
        id: 92,
        label: "환불 내역",
        link: "/payment/refund-history",
        parentId: 9,
      },
    ],
  },
  {
    id: 10,
    label: "고객센터",
    icon: "bx-support",
    subItems: [
      {
        id: 101,
        label: "공지사항 관리",
        link: "/support/notice-management",
        parentId: 10,
      },
      {
        id: 102,
        label: "FAQ 관리",
        link: "/support/faq-management",
        parentId: 10,
      },
      {
        id: 103,
        label: "1:1 문의 관리",
        link: "/support/inquiry-management",
        parentId: 10,
      },
    ],
  },
  {
    id: 11,
    label: "약관 및 정책 관리",
    icon: "bx-file-doc",
    link: "/support/privacy-management",
  },
];
